import React from 'react';

export const MenuCloseIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.75 5.25L5.25 18.75" stroke="#1B1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.75 18.75L5.25 5.25" stroke="#1B1C1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
